import { USER_SETTINGS_MODAL_QUERY_PARAM } from "@/components/settings/user-settings-constants";
import { useDefaultRedirect } from "@/hooks/use-default-redirect";
import { useFlagSettingsSplitEnabled } from "@/hooks/use-flag";
import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

type UserSettingsTab = "profile" | "secrets" | "git-authentications" | "personal-access-tokens" | "integrations";

const pathToModalTab: Record<string, UserSettingsTab> = {
    "/settings/profile": "profile",
    "/settings/secrets": "secrets",
    "/settings/git-authentications": "git-authentications",
    "/settings/personal-access-tokens": "personal-access-tokens",
    "/settings/user-integrations": "integrations",
    "/settings/preferences": "profile",
};

type Props = {
    children: ReactNode;
};

/**
 * Redirects the user to the new user settings modal if needed
 */
export const UserSettingsRedirect: FC<Props> = ({ children }) => {
    const { value: settingsSplitEnabled, loading: settingsLoading } = useFlagSettingsSplitEnabled();
    const location = useLocation();
    const redirectTo = useDefaultRedirect();

    if (settingsLoading || !redirectTo) {
        return null;
    }

    if (!settingsSplitEnabled) {
        return <>{children}</>;
    }

    const modalTab = pathToModalTab[location.pathname] ?? "profile";

    return <Navigate to={{ pathname: redirectTo, search: `?${USER_SETTINGS_MODAL_QUERY_PARAM}=${modalTab}` }} replace />;
};
